import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';

export const Header = styled.header`
  margin-bottom: ${layout.spacing.xSmall};
  padding: 0 ${layout.spacing.xSmall};
`;

export const Title = styled.h1`
  font-size: ${remCalc(36)};
  font-weight: normal;
  margin-bottom: ${layout.spacing.xSmall};

  ${media.mediumDown`
    font-size: ${remCalc(22)};
  `}
`;

export const Description = styled.div`
  max-width: 36em;
`;
